import React from "react";
import { Popover } from "reactstrap";
import { isFunction } from "lodash";

const withPopover =
  ({
    isOpen = false,
    toggleKey = "togglePopover",
    setIsOpenKey = "setIsPopoverOpen",
    isOpenKey = "isPopoverOpen",
    componentKey = "Popover",
  } = {}) =>
  (BaseComponent) =>
    class extends React.Component {
      state = { isOpen: isFunction(isOpen) ? isOpen(this.props) : isOpen };

      toggle = () => this.setState({ isOpen: !this.state.isOpen });
      setIsOpen = (isOpen) => this.setState({ isOpen: !!isOpen });

      renderPopover = (props) => (
        <Popover
          trigger="legacy"
          toggle={this.toggle}
          isOpen={this.state.isOpen}
          {...props}
        />
      );

      render = () => {
        const props = {
          [toggleKey]: this.toggle,
          [isOpenKey]: this.state.isOpen,
          [componentKey]: this.renderPopover,
          [setIsOpenKey]: this.setIsOpen,
        };

        return <BaseComponent {...this.props} {...props} />;
      };
    };

export default withPopover;
